/**
 * Pathname of a builder URL, falling back to the input when it isn't a parseable
 * absolute URL (a bare path, or an empty string before the preview is pointed
 * anywhere). Shared so the slice's `path` selectors and anything comparing a
 * mod's `createdAtUrl` against them agree on what "same page" means.
 */
export function extractPathname(url: string): string {
  try {
    return new URL(url).pathname;
  } catch {
    return url || "/";
  }
}
